export const chartDrawn = e => {
  e.chart.chartDiv.childNodes[1].innerText = "";
};



// WEBPACK FOOTER //
// ./src/utilities/charts.js